// extracted by mini-css-extract-plugin
module.exports = {"header":"Navigation_header__2Xi6z","appLogo":"Navigation_appLogo__3EED2","appTitle":"Navigation_appTitle__3Qa9d","headerRight":"Navigation_headerRight__3xwuB"};